export default __webpack_public_path__ + "static/media/dolar.072c9d62.svg";